export const defaultCuttingHeightRecord: SetCuttingHeightRecord = {
  isOpen: false,
};

export const defaultCuttingHeightModalRecord: CuttingHeightModalRecord = {
  isOpen: false,
  currentMissionId: null,
  selectedMissionId: null,
};

interface SetCuttingHeightRecord {
  isOpen: boolean;
}

export interface CuttingHeightModalRecord {
  isOpen: boolean;
  currentMissionId: number | string | null;
  selectedMissionId: number | string | null;
}

export default SetCuttingHeightRecord;
